import {useActions, useGetters, useMutators, useState} from './_default';
export default {
    namespaced: true,
    state: {
        ...useState(),
    },
    getters: {
        ...useGetters(),
    },
    mutations: {
        ...useMutators(),
    },
    actions: {
        ...useActions(),
    },
}
